import { render, staticRenderFns } from "./five_star.vue?vue&type=template&id=1f48cebc&scoped=true"
import script from "./five_star.vue?vue&type=script&lang=js"
export * from "./five_star.vue?vue&type=script&lang=js"
import style0 from "./five_star.vue?vue&type=style&index=0&id=1f48cebc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48cebc",
  null
  
)

export default component.exports